import { connect } from 'react-redux'
import { openEmailVerifyModal } from 'Modules/modals/actions'
import { getUserIsOneOfAgentAdminSupport } from 'Modules/user/data/selectors'
import ListingListViewContent from './ListingListViewContent'

const mapStateToProps = state => ({
  userIsOneOfAgentAdminSupport: getUserIsOneOfAgentAdminSupport(state),
})
const actions = {
  openEmailVerifyModal,
}

export default connect(mapStateToProps, actions)(ListingListViewContent)
